// extracted by mini-css-extract-plugin
export default {"btn_close":"BtnClose_btn_close__gse2r"};